/**
 * Created by linli on 7/13/2015.
 */
'use strict';

/**
 *   rewrote by rak , place the clear icon right after input box of jqx on mouseover , hide clear selection on mouseout,
 *   icon gets click event for clearing the content and can respond with event after clearing if specified as mentioned below.
 *
 *  directive attribute can have a object  clear-input= '{"responseType":1}' , can assign an object of this json format too .
 *
 *  if value responseType 1. return a event 'combobox-clear-selection-evt' broadcast on rootscope  , after clear icon clicked
 *  can be caught and do required function call on directive or in controller .
 *
 *  it can have 3 different types of classed based on component it defined
 *  1. searchclear -  for the normal combobox
 *  2. searchclear-multiselect - for overview multiselect
 *  3. searchclear-jqxinputselect - for jqx input used under basic data input directive.
 *
 * rewrote due to Bug 79654 - Rendering of overview search box not O.k for smaller resolutions
 * and other issues on some screens click is not responding with the combobox dropdown.
 *
 */
angular.module('betosyswebapp').directive('clearInput', ['$parse', '$rootScope',
    function ($parse, $rootScope) {
      return {
        link: function ($scope, elm, attr) {
          // register mouseover , mouseout event listenrs
          elm.bind('mouseover', mouseOverHandler);
          elm.bind('mouseout', mouseOutHandler);
          var afterClearResponseType = null;
          if (attr.clearInput.length > 0) {
            if (typeof  attr.clearInput === 'string') {
              afterClearResponseType = JSON.parse(attr.clearInput);
            }
            else {
              afterClearResponseType = attr.clearInput;
            }
          }


          function mouseOverHandler() {
            var removeCircleElement = $(elm).find('.glyphicon-remove-circle');
            var inputElement = $(elm).find('.jqx-combobox-content input');
            var customCssClass = getCustomClass(1);
            if (inputElement.length === 0) {
              inputElement = $(elm);
              customCssClass = getCustomClass(3); // jqx-input from basicDataInputField.js
              if (inputElement.length === 0) {
                return;
              }
            }

            // find is it a multi select combobox , if so need 10px top ,
            var isMultiSelect = $(elm).find('.jqx-combobox-content a').length > 0;
            if (isMultiSelect) {
              customCssClass = getCustomClass(2);
            }
            if (removeCircleElement.length === 0) {
              removeCircleElement = $(elm).next('div .glyphicon-remove-circle');
            }

            // clear icon div is already added if length > 0
            if (removeCircleElement.length === 0 && !hasDisabledClass(elm)) {
              var isNeedNgHide = 'ng-hide ';
              if (inputElement.val() || $(elm).find('.jqx-combobox-content a').length > 0) {
                isNeedNgHide = ' ';
              }


              var clearIcon = '<div id=' + Math.round(Math.random() * 1000000000) + ' class="' + isNeedNgHide + ' ' + customCssClass + ' ' + 'glyphicon glyphicon-remove-circle "></div>';
              clearIcon = angular.element(clearIcon);

              inputElement.after(clearIcon);

              clearIcon.on('click', clearIconClickHandler);
            } else if(!hasDisabledClass(elm)){
              if (removeCircleElement.hasClass('ng-hide') && inputElement.val() || $(elm).find('.jqx-combobox-content a').length > 0) {
                removeCircleElement.removeClass('ng-hide');
              }
            }
          }

          var hasDisabledClass = function (element) {
            var disabledClasses = ['jqx-combobox-content-disabled', 'disabled', 'ng-disabled', 'jqx-fill-state-disabled', 'jqx-fill-state-disabled-bootstrap', 'jqx-combobox-state-disabled'];
            var isDisabled = false;
            for (var i in disabledClasses) {
              if (disabledClasses.hasOwnProperty(i) && $(element).hasClass(disabledClasses[i])) {
                isDisabled = true;
              }
            }
            if ($(element).attr('disabled') === 'disabled') {
              isDisabled = true;
            }

            return isDisabled;
          };

          function mouseOutHandler() {
            var removeCircleElement = $(elm).find('.glyphicon-remove-circle');
            if (removeCircleElement.length === 0) {
              return;
              /* removeCircleElement = $(elm).next('div .glyphicon-remove-circle'); // getting a loop when used under jqxInput
               if (removeCircleElement.length === 0) {
                 return;
               }*/
            }
            removeCircleElement.addClass('ng-hide');
          }

          function getCustomClass(customClassSelectorValue) {
            switch (customClassSelectorValue) {
              case  1:
                return ' searchclear ';
              case 2:
                return ' searchclear-multiselect ';
              case 3:
                return ' searchclear-jqxinputselect ';
            }
          }

          function clearIconClickHandler() {
            var clearIcon = $(elm).find('.glyphicon-remove-circle');
            var isFromBasicInputDirective = false;
            if (clearIcon.length === 0) {
              clearIcon = $(elm).next('div .glyphicon-remove-circle');
              if (clearIcon.length > 0) {
                isFromBasicInputDirective = true;
              }
            }
            if (!isFromBasicInputDirective) { // will be handled in respective BasicInput directive
              if ($scope.$parent && $scope.$parent.$parent && $scope.$parent.$parent.$parent && $scope.$parent.$parent.$parent.isDirty) {
                $scope.$parent.$parent.$parent.isDirty = true;
              }
              try {
                $parse(attr.ngModel).assign($scope, null);
                $scope.$apply();
              }
              catch (error) {
                console.log(error);
              }
            }
            clearIcon.addClass('ng-hide');

            //todo(ejt) differntiate here and dont run all selectors
            //todo(ejt) hide on disabled and dont delete then!!
            var input = $(elm).find('input');
            input.select();

            if ($('#' +elm[0].id).jqxInput) {
              $('#' +elm[0].id).jqxInput('val', null);
            }

            $('#' +elm[0].id).jqxComboBox('clearSelection');
            $('#' +elm[0].id).jqxComboBox('searchString', '');
            $('#' +elm[0].id).jqxComboBox('focus');

            // after clear response as event
            if (afterClearResponseType && afterClearResponseType.responseType === 1) {
              $rootScope.$broadcast('combobox-clear-selection-evt', {id: attr.id});
            }
          }

          // destroy handlers
          $scope.$on('$destroy', function () {
            // unbind the click event from clear icon
            var removeCircleElement = $(elm).find('.glyphicon-remove-circle');
            if (removeCircleElement.length === 0) {
              removeCircleElement = $(elm).next('div .glyphicon-remove-circle');
            }
            removeCircleElement.unbind('click', clearIconClickHandler);
            elm.unbind('mouseover', mouseOverHandler);
            elm.unbind('mouseout', mouseOutHandler);
          });
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/clearInputDirective.js